module.exports = __webpack_public_path__ + "static/schaukel02-2bd75022c74b17eef929823d78af036f.jpg";